import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collapse"
export default class extends Controller {
  static values = {
    show: { type: Boolean, default: false },
  };

  static targets = ["toggle", "container"];

  initialize() {
    this.connected = false;
    this.show = false;
  }

  connect() {
    this.connected = true;

    this.show = this.showValue;
    this.setInitialState();
  }

  disconnect() {
    this.connected = false;
  }

  containerTargetConnected() {
    if (this.connected) {
      this.setInitialState();
    }
  }

  showValueChanged() {
    if (this.connected) {
      this.show = this.showValue;
      this.applyCurrentShow();
    }
  }

  toggle(ev) {
    ev.preventDefault();

    this.show = !this.show;
    this.applyCurrentShow();
  }

  setInitialState() {
    this.$collapse = $(this.containerTargets).collapse({
      toggle: false,
    });

    this.applyCurrentShow();
  }

  applyCurrentShow() {
    this.$collapse.collapse(this.show ? "show" : "hide");

    this.toggleTarget.classList.toggle("fa-caret-right", !this.show);
    this.toggleTarget.classList.toggle("fa-caret-down", this.show);
  }
}
